module.exports = __webpack_public_path__ + "static/img/02-06.848206c3.png";